import { takeLatest } from 'redux-saga'
import { call, put, select } from 'redux-saga/effects'

import actionTypes from 'redux/actions/actionTypes'
import desmosActions from 'redux/actions/desmosActions'
import { desmosSelectors } from 'redux/selectors'
import { desmosSync } from 'sync'
import callAny from './helpers/call_any'
import { localize } from 'helpers/translator'

function *desmosCreateInitialize(action) {
	try {
		const response = yield callAny(desmosSync.getDesmos, action.desmosUID)
		yield put(desmosActions.initializeDesmosSuccess(response.payload.desmos))
	} catch (error) {
		yield put(desmosActions.initializeDesmosError())
	}
}

function *desmosGetResultsWith(mode) {
	try {
		const response = yield callAny(desmosSync.getResults, mode)
		yield put(desmosActions.getResultsSuccess(response.payload.desmos))
	} catch (error) {
		yield put(desmosActions.getResultsError())
	}
}

function *desmosGetResults() {
	yield call(desmosGetResultsWith, 'initial')
	yield call(desmosGetResultsWith, 'complete')
}

function *desmosSaveDesmos() {
	try {
		const validationSelector = yield select(desmosSelectors.desmosValidationSelector)
		if (validationSelector.valid) {
			yield put(desmosActions.validationSuccess(localize('desmos_validation_completed_succesfully')))
			const saveSelector = yield select(desmosSelectors.saveSelector)
			const response = yield callAny(desmosSync.saveDesmos, saveSelector.entityUID, saveSelector.categoryID, saveSelector.pickID)
			yield put(desmosActions.saveDesmosSuccess(response.payload.desmos.redirectUrl))
		} else {
			yield put(desmosActions.validationError(validationSelector.message))
		}
	} catch (error) {
		let errorMessage = localize('global_generic_error')
		if (error.serverError && error.serverError.message) {
			errorMessage = error.serverError.message
		}

		yield put(desmosActions.saveDesmosError(errorMessage))
	}
}

export default [
	takeLatest([actionTypes.DESMOS_INITIALIZE_CREATION_TOOL,
		actionTypes.DESMOS_INITIALIZE_CREATION_TOOL_STANDALONE], desmosCreateInitialize),
	takeLatest(actionTypes.DESMOS_INITIALIZE_SUCCESS, desmosGetResults),
	takeLatest(actionTypes.DESMOS_GRAPH_SELECTED, desmosSaveDesmos),
]

export {
	desmosCreateInitialize,
	desmosGetResults,
	desmosGetResultsWith,
	desmosSaveDesmos,
}
